import { DataHelper, Notice } from '@hub/shared'
import ElementClickableComponent from '@src/components/element-clickable/element-clickable.component'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import './campaign-card-notices.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  notice: Notice
}

export default ({ notice }: Props) => {
  const [t] = useTranslation('campaignMaterialNoticesPage')
  const dataHelper = useMemo(() => new DataHelper(), [])

  return (
    <div className="card-notices p-3 mb-4">
      <div className="card-title display-flex align-items-flex-start justify-content-space-between m-0">
        <h5 className="justify-self-flex-start">{notice?.title}</h5>
        <span style={{ fontSize: '0.86rem' }}>{dataHelper.formatTimeFormatAgo(notice?.createdAt)}</span>
      </div>
      <div className="py-3">
        <p className="clean-style" dangerouslySetInnerHTML={{ __html: notice?.description }}></p>
      </div>
      {notice?.attachmentUrls?.map((link, index) => (
        <ElementClickableComponent key={link} fileDownload={link} title={`${t('attachmentName')} ${index + 1}.pdf`} />
      ))}
      <div className="card-author pt-3">
        <strong>
          <p>{t('by')}</p>
          {notice.author.name}
        </strong>
      </div>
    </div>
  )
}
